import { render, staticRenderFns } from "./formProposta_p2.vue?vue&type=template&id=45e74ed5&scoped=true"
import script from "./formProposta_p2.vue?vue&type=script&lang=js"
export * from "./formProposta_p2.vue?vue&type=script&lang=js"
import style0 from "./formProposta_p2.vue?vue&type=style&index=0&id=45e74ed5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e74ed5",
  null
  
)

export default component.exports